import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const NormalIcon: FC<IconProps> = memo(
  ({ width, height, size, color, style }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 36 36"
        fill="none"
        style={style}
      >
        <Path
          d="M14.8299 23.8542C14.9482 24.0193 15.1041 24.1538 15.2847 24.2466C15.4653 24.3394 15.6655 24.3878 15.8685 24.3878C16.0716 24.3878 16.2717 24.3394 16.4523 24.2466C16.633 24.1538 16.7889 24.0193 16.9071 23.8542L25.3687 12.1221C25.5214 11.9091 25.3687 11.6118 25.1076 11.6118H23.2232C22.8134 11.6118 22.4237 11.8087 22.1826 12.1462L15.8705 20.9051L13.0098 16.9355C12.7687 16.602 12.383 16.4011 11.9692 16.4011H10.0848C9.82366 16.4011 9.67098 16.6984 9.82366 16.9114L14.8299 23.8542Z"
          fill={color}
        />
        <Path
          d="M32.7857 1.92871H3.2143C2.50314 1.92871 1.92859 2.50326 1.92859 3.21443V32.7859C1.92859 33.497 2.50314 34.0716 3.2143 34.0716H32.7857C33.4969 34.0716 34.0714 33.497 34.0714 32.7859V3.21443C34.0714 2.50326 33.4969 1.92871 32.7857 1.92871ZM31.1786 31.1787H4.82145V4.82157H31.1786V31.1787Z"
          fill={color}
        />
      </Svg>
    );
  },
);
